import { useEffect, useState } from 'react';

const FB_APP_ID = '1095169645456061';
const FB_SDK_VERSION = 'v21.0';
const FB_SDK_SRC = 'https://connect.facebook.net/en_US/sdk.js';

let sdkLoadPromise = null;

function loadSdk() {
  if (sdkLoadPromise) return sdkLoadPromise;

  sdkLoadPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('window unavailable'));
      return;
    }

    if (window.FB) {
      resolve(window.FB);
      return;
    }

    const prevInit = window.fbAsyncInit;
    window.fbAsyncInit = function () {
      try {
        if (typeof prevInit === 'function') prevInit();
      } catch (_) {}
      try {
        window.FB.init({
          appId: FB_APP_ID,
          version: FB_SDK_VERSION,
          cookie: false,
          xfbml: false,
        });
        resolve(window.FB);
      } catch (e) {
        reject(e);
      }
    };

    const existing = document.querySelector(`script[src="${FB_SDK_SRC}"]`);
    if (existing) return;

    const script = document.createElement('script');
    script.src = FB_SDK_SRC;
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      sdkLoadPromise = null;
      reject(new Error('FB SDK script failed to load'));
    };
    document.head.appendChild(script);
  });

  return sdkLoadPromise;
}

export default function useFacebookSDK() {
  const [state, setState] = useState({ FB: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    loadSdk()
      .then((FB) => {
        if (!cancelled) setState({ FB, loading: false, error: null });
      })
      .catch((err) => {
        if (!cancelled) setState({ FB: null, loading: false, error: err.message || 'sdk_load_failed' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
